<template>
  <div>
    <page-heading-info
    title="Jefferson County Auditor's Office"
    phone="(740) 283-8511"
    courthouse="true"
    hours="8:30 - 4:30 (M-F)"
    floor="4th Floor"
    ></page-heading-info>

    <div class="row">
      <div class="col-md-6 mt-3">
        <div class="cov-title">Jefferson County COVID-19 Small Business/Non-Profit Emergency Relief Grant Program</div>
        <hr class="hr-weight" />

        <p class="mt-3">
          The following applicants have been awarded a grant under the
          Jefferson County COVID-19 Small Business/Non-Profit Emergency Relief
          Grant Program.
        </p>
        <p>
          Grant Award Agreements will be emailed to successful applicants. These
          Grant Award Agreement must be completed, signed, dated, and returned to
          the County Auditor's Office no later than December 22, 2020.
          Complete instructions will be included on the Grant Award Agreements.
        </p>
      </div>

      <div class="col-md-6 mt-3 image-flex order-0 order-md-1">
        <img src="https://jeffersoncountyoh.com/static/images/general/lake_01.jpg" class="border-1 text-dark" />
      </div>
    </div>
	
	<div style="font-weight: bold; font-size: 1.25em;" class="mt-3">Applicants Awarded Grants Under The Program </div>
	<hr class="hr-weight" />
	
	<div class="row mt-2">
    <div class="col-md-6 mt-3">
      <ul>
        <li>Nelson Sourcing LLC</li>
        <li>Steubenville Lions Club</li>
        <li>Steubenville Historic Landmarks Foundation</li>
        <li>Rehab Plus Physical Therapy</li>
        <li>Dungeon Hollow Brewing Company</li>
        <li>Festival in the Woods</li>
        <li>Holy Trinity Greek Orthodox Church</li>
        <li>Baby-Boyz BBQ LLC</li>
        <li>New Image Remodeling and Repair LLC</li>
        <li>Envy Salon 3 LLC</li>
        <li>Keller &amp; Co Hair Studio LLC</li>
        <li>Esquire Cleaners LLC</li>
        <li>Miniature Wardrobe LLC</li>
        <li>Zalenski Family Eatery &amp; Pub</li>
        <li>Mrs. T's Tavern</li>
        <li>Celebrations</li>
        <li>Dean A. Collaros &amp; Associates</li>
        <li>Two Brothers Dry Cleaners</li>
        <li>Bradley Lawn-Scapes</li>
        <li>VRHQ LLC</li>
        <li>Quinn Memorial AME Church</li>
        <li>Legacy Property Inspections LLC</li>
        <li>Mt. Calvary Cemetery Association</li>
        <li>The Gem Fitness LLC</li>
        <li>Willa's Supreme Touch</li>
        <li>A Nails Charm</li>
        <li>Jefferson County Humane Society</li>
        <li>Buckeye Field Maintenance Inc</li>
        <li>Gina's Carryout Favorites</li>
        <li>Uncle Johnny Delivers</li>
        <li>Thorn's Kitchen and Catering</li>
        <li>Galaxy Games LLC</li>
        <li>Scaffidi's Pasta Inc</li>
        <li>Pleasant Hill School House Historical Museum</li>
        <li>Aim Women's Center</li>
        <li>Ohio Valley Down Syndrom Support Group</li>
        <li>Connie Yeager Tax &amp; Accounting Inc</li>
        <li>Optimum Blinds</li>
        <li>Desperado Dogs</li>
        <li>Downtown Bakery</li>

      </ul>
	  </div>
    <div class="mt-3 col-md-6">
      <ul>
        <li>Valley Wine Cellar Inc</li>
        <li>Lighthouse Counseling and Mediation</li>
        <li>American Legion Club of Toronto, Ohio Inc</li>
        <li>Origin Fitness Center Inc.</li>
        <li>Center of Hope</li>
        <li>Bella Lux Images</li>
        <li>Mount Carmel Community Baptist Church</li>
        <li>Yorgo's Gyro-Potatoes</li>
        <li>Urban Mission Ministires</li>
        <li>Sesame Grill Inc</li>
        <li>RKG Consulting Services LLC</li>
        <li>Convenient Food Mart</li>
        <li>Ed McCauslen Florist Inc</li>
        <li>Portraits With Pride LLC</li>
        <li>United Way</li>
        <li>Homol Construction Inc</li>
        <li>Ohio Valley Health Center</li>
        <li>Mary Seat of Wisdom Classical Community</li>
        <li>Gaslite Inc</li>
        <li>Mama G's Catering</li>
        <li>Clancey Printing Inc</li>
        <li>Fraternal Order of Eagles 1572</li>
        <li>Fresh Twist LLC</li>
        <li>Bowers Landscape Design LLC</li>
        <li> W Mitchell of Ohio</li>
        <li>Johnson's White Bear</li>
        <li>Ohio Catering and Carry-Out</li>
        <li>Fort Steuben Opthalmologists Inc</li>
        <li>Serenity Hair</li>
        <li>Cathy's Ceramics &amp; Crafts</li>
        <li>Movin &amp; Groovin Productions</li>
      </ul>
    </div>

	 </div>

    <!-- 
    <div class="row">
      <div class="col">
        <text-box-title class="mt-3" title="Grant Program Document Downloads">
          <note-documents note-id="34" class="ml-3 mr-3 mt-3"></note-documents>
        </text-box-title>
      </div>
    </div>
    -->

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'

export default {
	components: {
		PageHeadingInfo,
    TextBoxTitle,
    NoteDocuments
	},
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style scoped>
  .hr-weight {
    background-color: #8db8db;
    border: 0 none;
    color: #8db8db;
    height: 3px;
  }

  .cov-title {
    font-size: 1.25em;
    font-weight: bold;
    line-height: 1.5em;
  }
</style>